import { Col, Divider, Row, Space, Typography } from "antd";
import { CustomTextField, MoneyText } from "~/components";
import * as APITypes from "~/API";
import { EntityStatusTag } from "~/components/Tags/EntityStatusTag";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const BuildingDetailsTab = ({
  buildingDetails,
  propertyDetails,
}: {
  buildingDetails: APITypes.Building;
  propertyDetails: APITypes.Property;
}) => {
  const { t } = useAppTranslation();
  return (
    <>
      <div style={{ marginTop: "2rem" }}>
        <Row gutter={12}>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Number")}
              </Typography.Text>
              <CustomTextField value={buildingDetails.name || ""} />
            </Space>
          </Col>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Contact")}
              </Typography.Text>
              <CustomTextField value={buildingDetails.contact || ""} />
            </Space>
          </Col>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Price")}
              </Typography.Text>
              <MoneyText value={buildingDetails.price || ""} />
            </Space>
          </Col>
        </Row>

        <Row gutter={12} style={{ marginTop: "2rem" }}>
          <Col span={24}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Description")}
              </Typography.Text>
              <CustomTextField value={buildingDetails.description || ""} />
            </Space>
          </Col>
        </Row>

        {buildingDetails.rent && (
          <>
            <Row gutter={12} style={{ marginTop: "2rem" }}>
              <Col span={8}>
                <Space direction="vertical">
                  <Typography.Text strong style={{ marginBottom: 5 }}>
                    {t("Status")}
                  </Typography.Text>
                  <EntityStatusTag status={buildingDetails.status} />
                </Space>
              </Col>
              <Col span={8}>
                <Space direction="vertical">
                  <Typography.Text strong style={{ marginBottom: 5 }}>
                    {t("Number_of_bedrooms")}
                  </Typography.Text>
                  <CustomTextField value={buildingDetails.numBedroom || ""} />
                </Space>
              </Col>
              <Col span={8}>
                <Space direction="vertical">
                  <Typography.Text strong style={{ marginBottom: 5 }}>
                    {t("Number_of_bathrooms")}
                  </Typography.Text>
                  <CustomTextField value={buildingDetails.numBathroom || ""} />
                </Space>
              </Col>
            </Row>
            <Row gutter={12} style={{ marginTop: "2rem" }}>
              <Col span={8}>
                <Space direction="vertical">
                  <Typography.Text strong style={{ marginBottom: 5 }}>
                    {t("Rent")}
                  </Typography.Text>
                  <MoneyText value={buildingDetails.rent || ""} />
                </Space>
              </Col>
            </Row>
          </>
        )}

        <Divider />
        <Typography.Title level={5}>
          {t("Location_Information")}
        </Typography.Title>

        <Row gutter={12}>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Street")}
              </Typography.Text>
              <CustomTextField value={buildingDetails.street || ""} />
            </Space>
          </Col>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("City")}
              </Typography.Text>
              <CustomTextField value={propertyDetails.city || ""} />
            </Space>
          </Col>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("State")}
              </Typography.Text>
              <CustomTextField value={propertyDetails.state || ""} />
            </Space>
          </Col>
        </Row>

        <Row gutter={12} style={{ marginTop: "2rem" }}>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Zipcode")}
              </Typography.Text>
              <CustomTextField value={propertyDetails.zipCode || ""} />
            </Space>
          </Col>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("PO_Box")}
              </Typography.Text>
              <CustomTextField value={propertyDetails.poBox || ""} />
            </Space>
          </Col>
          <Col span={8}>
            <Space direction="vertical">
              <Typography.Text strong style={{ marginBottom: 5 }}>
                {t("Country")}
              </Typography.Text>
              <CustomTextField value={propertyDetails.country || ""} />
            </Space>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BuildingDetailsTab;
